import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 12,
    paddingTop: 10,
    paddingBottom: 5,
    paddingLeft: 20,
    paddingRight: 20,
    borderBottom: "1px solid #d4d4d4",
  },
  chip: {
    height: 21,
    borderRadius: 3,
    fontSize: 10,
    minWidth: 110,
    fontFamily: '"Nunito Sans", "Helvetica", "Arial", sans-serif',
    marginRight: 3,
    fontWeight: "bold",
  },
  icon: {
    fontSize: 14,
    color: "#fff",
  },
  type1: {
    backgroundColor: "#9ABC66",
    color: "#ffffff",
  },
  type2: {
    backgroundColor: "#79BFCE",
    color: "#ffffff",
  },
  type3: {
    backgroundColor: "#FA758A",
    color: "#ffffff",
  },
}));

export default useStyles;
